import { render } from "./ServiceTypeEdit.vue?vue&type=template&id=62dc8746&scoped=true"
import script from "./ServiceTypeEdit.vue?vue&type=script&lang=js"
export * from "./ServiceTypeEdit.vue?vue&type=script&lang=js"

import "./ServiceTypeEdit.vue?vue&type=style&index=0&id=62dc8746&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dc8746"]])

export default __exports__